mod.modules.define("NewsAndAnalysis", "BaseModule", function (fn) {

	fn.prototype.init = function (params) {
		this.base("init", params);

		if (this.el.find("div.pager-wrap").length) {
			this.addPlugin("Plugin-Paging");
		}
	};

});